export function getIsoFormat(date: any, keepTime: boolean = false): string {
	if (!date) {
		return '';
	}

	const d = new Date(date);

	if (!keepTime) {
		d.setHours(12, 0, 0, 0);
	}

	return d.toISOString().replace(/\.[0-9]{3}Z/, 'Z');
}
